import config from '../services/config';

export const APPLE_SSO_CALLBACK_PATH = '/auth/apple-sso-callback';

export const getAppleConnectUrl = (): string => {
  const callback = encodeURIComponent(`${window.location.origin}${APPLE_SSO_CALLBACK_PATH}`);
  return `${config.api_url}/api/connect/apple?callback=${callback}`;
};
